// Application route inventory. Original source paths are retained only as migration provenance.
export const legacyRoutes = [
  {
    "route": "/",
    "source": "Pages/Home.razor"
  },
  {
    "route": "/access-denied",
    "source": "Pages/Auth/AccessDenied.razor"
  },
  {
    "route": "/admin/builds",
    "source": "Pages/Admin/BuildMonitorPage.razor"
  },
  {
    "route": "/admin/llm-settings",
    "source": "Pages/Admin/LlmSettings.razor"
  },
  {
    "route": "/admin/mcp-settings",
    "source": "Pages/Admin/McpSettings.razor"
  },
  {
    "route": "/admin/quiz-analytics",
    "source": "Pages/Admin/QuizAnalytics.razor"
  },
  {
    "route": "/admin/quiz-batch",
    "source": "Pages/Admin/QuizBatchGenerator.razor"
  },
  {
    "route": "/admin/quiz-generator",
    "source": "Pages/Admin/QuizGenerator.razor"
  },
  {
    "route": "/admin/user-access",
    "source": "Pages/Admin/UserAccessPage.razor"
  },
  {
    "route": "/auth/magic-link/{Token}",
    "source": "Pages/Auth/MagicLinkLoginPage.razor"
  },
  {
    "route": "/auth/request-link",
    "source": "Pages/Auth/RequestLinkPage.razor"
  },
  {
    "route": "/auth/validate-link",
    "source": "Pages/Auth/MagicLinkLoginPage.razor"
  },
  {
    "route": "/counter",
    "source": "Pages/Counter.razor"
  },
  {
    "route": "/education/biology",
    "source": "Pages/Biology/BiologyPage.razor"
  },
  {
    "route": "/education/biology/cellule",
    "source": "Pages/Biology/BiologyCellsPage.razor"
  },
  {
    "route": "/education/biology/piante",
    "source": "Pages/Biology/BiologyPiantePage.razor"
  },
  {
    "route": "/education/chinese/course",
    "source": "Pages/Chinese/Course/ChineseCoursePage.razor"
  },
  {
    "route": "/education/chinese/course/unit-{Number:int}",
    "source": "Pages/Chinese/Course/ChineseUnitPage.razor"
  },
  {
    "route": "/education/english",
    "source": "Pages/English/EnglishPage.razor"
  },
  {
    "route": "/education/english/course",
    "source": "Pages/English/Course/EnglishCoursePage.razor"
  },
  {
    "route": "/education/english/course/unit-{Number:int}",
    "source": "Pages/English/Course/UnitPage.razor"
  },
  {
    "route": "/education/english/grammar",
    "source": "Pages/English/EnglishGrammarPage.razor"
  },
  {
    "route": "/education/english/vocabulary",
    "source": "Pages/English/EnglishVocabularyPage.razor"
  },
  {
    "route": "/education/geography",
    "source": "Pages/Geography/GeographyPage.razor"
  },
  {
    "route": "/education/geography/plate-tectonics",
    "source": "Pages/Geography/PlateTectonicsPage.razor"
  },
  {
    "route": "/education/geography/volcano",
    "source": "Pages/Geography/VolcanoPage.razor"
  },
  {
    "route": "/education/geography/water-cycle",
    "source": "Pages/Geography/WaterCyclePage.razor"
  },
  {
    "route": "/education/history",
    "source": "Pages/History/HistoryPage.razor"
  },
  {
    "route": "/education/history/{Slug}",
    "source": "Pages/History/HistoryEventPage.razor"
  },
  {
    "route": "/education/history/timeline",
    "source": "Pages/History/TimelinePage.razor"
  },
  {
    "route": "/education/informatica",
    "source": "Pages/Informatica/InformaticaPage.razor"
  },
  {
    "route": "/education/informatica/base",
    "source": "Pages/Informatica/InformaticaBasePage.razor"
  },
  {
    "route": "/education/informatica/programmazione",
    "source": "Pages/Informatica/InformaticaProgrammazionePage.razor"
  },
  {
    "route": "/education/informatica/programmazione/basic",
    "source": "Pages/Informatica/InformaticaBasicPage.razor"
  },
  {
    "route": "/education/informatica/programmazione/turtle",
    "source": "Pages/Informatica/InformaticaTurtlePage.razor"
  },
  {
    "route": "/education/informatica/programmazione/z80",
    "source": "Pages/Informatica/InformaticaZ80Page.razor"
  },
  {
    "route": "/education/italian",
    "source": "Pages/Italian/ItalianPage.razor"
  },
  {
    "route": "/education/italian/grammar-analysis",
    "source": "Pages/Grammar/GrammarAnalysisPage.razor"
  },
  {
    "route": "/education/italian/grammar-analysis/admin",
    "source": "Pages/Grammar/GrammarAdminPage.razor"
  },
  {
    "route": "/education/italian/grammar-analysis/admin/edit/{EditId}",
    "source": "Pages/Grammar/GrammarAdminPage.razor"
  },
  {
    "route": "/education/italian/grammar-analysis/admin/new",
    "source": "Pages/Grammar/GrammarAdminPage.razor"
  },
  {
    "route": "/education/italian/grammar-analysis/archive",
    "source": "Pages/Grammar/GrammarArchivePage.razor"
  },
  {
    "route": "/education/italian/grammar-analysis/archive/{SentenceSlug}",
    "source": "Pages/Grammar/GrammarArchivePage.razor"
  },
  {
    "route": "/education/italian/lettura",
    "source": "Pages/Italian/ItalianReadingPage.razor"
  },
  {
    "route": "/education/italian/lettura/comprensione",
    "source": "Pages/Italian/ItalianReadingComprehensionPage.razor"
  },
  {
    "route": "/education/italian/lettura/comprensione/parole-mancanti",
    "source": "Pages/Italian/ItalianReadingFillPage.razor"
  },
  {
    "route": "/education/italian/lettura/comprensione/storie-brevi",
    "source": "Pages/Italian/ItalianReadingShortStoriesPage.razor"
  },
  {
    "route": "/education/italian/lettura/comprensione/testi-lunghi",
    "source": "Pages/Italian/ItalianReadingLongTextsPage.razor"
  },
  {
    "route": "/education/italian/lettura/comprensione/vignette",
    "source": "Pages/Italian/ItalianReadingComicsPage.razor"
  },
  {
    "route": "/education/italian/lettura/frasi",
    "source": "Pages/Italian/ItalianReadingSentencesPage.razor"
  },
  {
    "route": "/education/italian/lettura/grillo-parlante",
    "source": "Pages/Italian/ItalianReadingGrilloPage.razor"
  },
  {
    "route": "/education/italian/lettura/parole",
    "source": "Pages/Italian/ItalianReadingWordsPage.razor"
  },
  {
    "route": "/education/italian/lettura/scrittura",
    "source": "Pages/Italian/ItalianReadingWritingPage.razor"
  },
  {
    "route": "/education/italian/lettura/sillabe",
    "source": "Pages/Italian/ItalianReadingSyllablesPage.razor"
  },
  {
    "route": "/education/italian/poesie",
    "source": "Pages/Italian/ItalianPoesiePage.razor"
  },
  {
    "route": "/education/italian/poesie/componimenti",
    "source": "Pages/Italian/ItalianPoesieComponentimentiPage.razor"
  },
  {
    "route": "/education/italian/poesie/componimenti/{Slug}",
    "source": "Pages/Italian/ItalianPoesieEsempiPage.razor"
  },
  {
    "route": "/education/italian/poesie/memorizzazione",
    "source": "Pages/Italian/ItalianPoesieMemorizzazionePage.razor"
  },
  {
    "route": "/education/italian/poesie/scrivere",
    "source": "Pages/Italian/ItalianPoesieScriverePage.razor"
  },
  {
    "route": "/education/italian/poesie/teoria",
    "source": "Pages/Italian/ItalianPoesieTeoriaPage.razor"
  },
  {
    "route": "/education/italian/scrittura",
    "source": "Pages/Italian/ItalianReadingWritingPage.razor"
  },
  {
    "route": "/education/italian/temi",
    "source": "Pages/Italian/ItalianTemiPage.razor"
  },
  {
    "route": "/education/italian/temi/esempi",
    "source": "Pages/Italian/ItalianTemiEsempiPage.razor"
  },
  {
    "route": "/education/italian/temi/esempi/{Type}/{Id:int}",
    "source": "Pages/Italian/ItalianTemiEsempioPage.razor"
  },
  {
    "route": "/education/italian/temi/esempi/argomentativo",
    "source": "Pages/Italian/ItalianTemiEsempiArgomenativoPage.razor"
  },
  {
    "route": "/education/italian/temi/esempi/descrittivo",
    "source": "Pages/Italian/ItalianTemiEsempiDescrittivoPage.razor"
  },
  {
    "route": "/education/italian/temi/esempi/narrativo",
    "source": "Pages/Italian/ItalianTemiEsempiNarrativoPage.razor"
  },
  {
    "route": "/education/italian/temi/esercizi",
    "source": "Pages/Italian/ItalianTemiEserciziPage.razor"
  },
  {
    "route": "/education/italian/temi/narrativa",
    "source": "Pages/Italian/ItalianTemiNarrativaPage.razor"
  },
  {
    "route": "/education/italian/temi/teoria",
    "source": "Pages/Italian/ItalianTemiTeoriaPage.razor"
  },
  {
    "route": "/education/italian/verbi",
    "source": "Pages/Italian/ItalianVerbiPage.razor"
  },
  {
    "route": "/education/italian/verbi/esercizi",
    "source": "Pages/Italian/ItalianVerbiEserciziPage.razor"
  },
  {
    "route": "/education/italian/verbi/forme-indefinite",
    "source": "Pages/Italian/ItalianVerbiFormePage.razor"
  },
  {
    "route": "/education/italian/verbi/introduzione",
    "source": "Pages/Italian/ItalianVerbiIntroduzionePage.razor"
  },
  {
    "route": "/education/italian/verbi/modi-tempi",
    "source": "Pages/Italian/ItalianVerbiModiTempiPage.razor"
  },
  {
    "route": "/education/japanese/course",
    "source": "Pages/Japanese/Course/JapaneseCoursePage.razor"
  },
  {
    "route": "/education/japanese/course/unit-{Number:int}",
    "source": "Pages/Japanese/Course/JapaneseUnitPage.razor"
  },
  {
    "route": "/education/knowledge",
    "source": "Pages/Knowledge/KnowledgePage.razor"
  },
  {
    "route": "/education/mathematics",
    "source": "Pages/Mathematics/MathematicsPage.razor"
  },
  {
    "route": "/education/mathematics/advanced-calculus-optimization",
    "source": "Pages/Mathematics/AdvancedCalculusOptimization/AdvancedCalculusOptimizationPage.razor"
  },
  {
    "route": "/education/mathematics/advanced-calculus-optimization/exercises",
    "source": "Pages/Mathematics/AdvancedCalculusOptimization/AdvancedCalculusOptimizationPage.razor"
  },
  {
    "route": "/education/mathematics/advanced-powers",
    "source": "Pages/Mathematics/AdvancedPowers/AdvancedPowersPage.razor"
  },
  {
    "route": "/education/mathematics/advanced-powers/exercises",
    "source": "Pages/Mathematics/AdvancedPowers/AdvancedPowersPage.razor"
  },
  {
    "route": "/education/mathematics/advanced-probability",
    "source": "Pages/Mathematics/AdvancedProbability/AdvancedProbabilityPage.razor"
  },
  {
    "route": "/education/mathematics/advanced-probability/exercises",
    "source": "Pages/Mathematics/AdvancedProbability/AdvancedProbabilityPage.razor"
  },
  {
    "route": "/education/mathematics/algebra",
    "source": "Pages/Mathematics/Algebra/AlgebraPage.razor"
  },
  {
    "route": "/education/mathematics/algebra/first-degree",
    "source": "Pages/Mathematics/Algebra/FirstDegree/AlgebraFirstDegreePage.razor"
  },
  {
    "route": "/education/mathematics/algebra/first-degree-problems",
    "source": "Pages/Mathematics/Algebra/FirstDegreeProblems/AlgebraFirstDegreeProblemsPage.razor"
  },
  {
    "route": "/education/mathematics/algebra/first-degree-problems/exercises",
    "source": "Pages/Mathematics/Algebra/FirstDegreeProblems/AlgebraFirstDegreeProblemsPage.razor"
  },
  {
    "route": "/education/mathematics/algebra/first-degree/exercises",
    "source": "Pages/Mathematics/Algebra/FirstDegree/AlgebraFirstDegreePage.razor"
  },
  {
    "route": "/education/mathematics/algebra/inequalities",
    "source": "Pages/Mathematics/Algebra/Inequalities/AlgebraInequalitiesPage.razor"
  },
  {
    "route": "/education/mathematics/algebra/monomials",
    "source": "Pages/Mathematics/Algebra/Monomials/AlgebraMonomialsPage.razor"
  },
  {
    "route": "/education/mathematics/algebra/monomials/exercises",
    "source": "Pages/Mathematics/Algebra/Monomials/AlgebraMonomialsPage.razor"
  },
  {
    "route": "/education/mathematics/algebra/polynomial-multiplication",
    "source": "Pages/Mathematics/Algebra/PolynomialMultiplication/AlgebraPolynomialMultiplicationPage.razor"
  },
  {
    "route": "/education/mathematics/algebra/polynomial-multiplication/exercises",
    "source": "Pages/Mathematics/Algebra/PolynomialMultiplication/AlgebraPolynomialMultiplicationPage.razor"
  },
  {
    "route": "/education/mathematics/algebra/polynomials",
    "source": "Pages/Mathematics/Algebra/Polynomials/AlgebraPolynomialsPage.razor"
  },
  {
    "route": "/education/mathematics/algebra/second-degree",
    "source": "Pages/Mathematics/Algebra/SecondDegree/AlgebraSecondDegreePage.razor"
  },
  {
    "route": "/education/mathematics/algebra/special-products",
    "source": "Pages/Mathematics/Algebra/SpecialProducts/AlgebraSpecialProductsPage.razor"
  },
  {
    "route": "/education/mathematics/algebra/systems",
    "source": "Pages/Mathematics/Algebra/Systems/AlgebraSystemsPage.razor"
  },
  {
    "route": "/education/mathematics/analytic-geometry",
    "source": "Pages/Mathematics/AnalyticGeometry/AnalyticGeometryPage.razor"
  },
  {
    "route": "/education/mathematics/analytic-geometry/exercises",
    "source": "Pages/Mathematics/AnalyticGeometry/AnalyticGeometryPage.razor"
  },
  {
    "route": "/education/mathematics/arithmetic/addition",
    "source": "Pages/Mathematics/Arithmetic/Addition/AdditionPage.razor"
  },
  {
    "route": "/education/mathematics/arithmetic/addition/exercises",
    "source": "Pages/Mathematics/Arithmetic/Addition/AdditionPage.razor"
  },
  {
    "route": "/education/mathematics/arithmetic/division",
    "source": "Pages/Mathematics/Arithmetic/LongDivision/LongDivisionPage.razor"
  },
  {
    "route": "/education/mathematics/arithmetic/division/concepts",
    "source": "Pages/Mathematics/Arithmetic/LongDivision/DivisionConceptsPage.razor"
  },
  {
    "route": "/education/mathematics/arithmetic/division/exercises",
    "source": "Pages/Mathematics/Arithmetic/LongDivision/LongDivisionPage.razor"
  },
  {
    "route": "/education/mathematics/arithmetic/multiplication",
    "source": "Pages/Mathematics/Arithmetic/Multiplication/MultiplicationPage.razor"
  },
  {
    "route": "/education/mathematics/arithmetic/multiplication/exercises",
    "source": "Pages/Mathematics/Arithmetic/Multiplication/MultiplicationPage.razor"
  },
  {
    "route": "/education/mathematics/arithmetic/subtraction",
    "source": "Pages/Mathematics/Arithmetic/Subtraction/SubtractionPage.razor"
  },
  {
    "route": "/education/mathematics/arithmetic/subtraction/exercises",
    "source": "Pages/Mathematics/Arithmetic/Subtraction/SubtractionPage.razor"
  },
  {
    "route": "/education/mathematics/calculus",
    "source": "Pages/Mathematics/Calculus/CalculusPage.razor"
  },
  {
    "route": "/education/mathematics/calculus/exercises",
    "source": "Pages/Mathematics/Calculus/CalculusPage.razor"
  },
  {
    "route": "/education/mathematics/cartesian-plane",
    "source": "Pages/Mathematics/CartesianPlane/CartesianPlanePage.razor"
  },
  {
    "route": "/education/mathematics/cartesian-plane/exercises",
    "source": "Pages/Mathematics/CartesianPlane/CartesianPlanePage.razor"
  },
  {
    "route": "/education/mathematics/complex-numbers",
    "source": "Pages/Mathematics/ComplexNumbers/ComplexNumbersPage.razor"
  },
  {
    "route": "/education/mathematics/complex-numbers/exercises",
    "source": "Pages/Mathematics/ComplexNumbers/ComplexNumbersPage.razor"
  },
  {
    "route": "/education/mathematics/computability-complexity",
    "source": "Pages/Mathematics/ComputabilityComplexity/ComputabilityComplexityPage.razor"
  },
  {
    "route": "/education/mathematics/computability-complexity/exercises",
    "source": "Pages/Mathematics/ComputabilityComplexity/ComputabilityComplexityPage.razor"
  },
  {
    "route": "/education/mathematics/computational-logic",
    "source": "Pages/Mathematics/ComputationalLogic/ComputationalLogicPage.razor"
  },
  {
    "route": "/education/mathematics/computational-logic/exercises",
    "source": "Pages/Mathematics/ComputationalLogic/ComputationalLogicPage.razor"
  },
  {
    "route": "/education/mathematics/cryptography-math",
    "source": "Pages/Mathematics/CryptographyMath/CryptographyMathPage.razor"
  },
  {
    "route": "/education/mathematics/cryptography-math/exercises",
    "source": "Pages/Mathematics/CryptographyMath/CryptographyMathPage.razor"
  },
  {
    "route": "/education/mathematics/data-science-statistics",
    "source": "Pages/Mathematics/DataScienceStatistics/DataScienceStatisticsPage.razor"
  },
  {
    "route": "/education/mathematics/data-science-statistics/exercises",
    "source": "Pages/Mathematics/DataScienceStatistics/DataScienceStatisticsPage.razor"
  },
  {
    "route": "/education/mathematics/discrete-math",
    "source": "Pages/Mathematics/DiscreteMath/DiscreteMathPage.razor"
  },
  {
    "route": "/education/mathematics/discrete-math/exercises",
    "source": "Pages/Mathematics/DiscreteMath/DiscreteMathPage.razor"
  },
  {
    "route": "/education/mathematics/divisibility",
    "source": "Pages/Mathematics/Divisibility/DivisibilityPage.razor"
  },
  {
    "route": "/education/mathematics/exponential-logarithms",
    "source": "Pages/Mathematics/ExponentialLogarithms/ExponentialLogarithmsPage.razor"
  },
  {
    "route": "/education/mathematics/exponential-logarithms/exercises",
    "source": "Pages/Mathematics/ExponentialLogarithms/ExponentialLogarithmsPage.razor"
  },
  {
    "route": "/education/mathematics/expressions",
    "source": "Pages/Mathematics/Expressions/ExpressionsPage.razor"
  },
  {
    "route": "/education/mathematics/expressions/exercises",
    "source": "Pages/Mathematics/Expressions/ExpressionsPage.razor"
  },
  {
    "route": "/education/mathematics/factorization",
    "source": "Pages/Mathematics/Factorization/FactorizationPage.razor"
  },
  {
    "route": "/education/mathematics/factorization/exercises",
    "source": "Pages/Mathematics/Factorization/FactorizationPage.razor"
  },
  {
    "route": "/education/mathematics/fractions",
    "source": "Pages/Mathematics/Fractions/FractionsPage.razor"
  },
  {
    "route": "/education/mathematics/fractions-percentages",
    "source": "Pages/Mathematics/FractionsMixed/FractionsMixedPage.razor"
  },
  {
    "route": "/education/mathematics/fractions-percentages/exercises",
    "source": "Pages/Mathematics/FractionsMixed/FractionsMixedPage.razor"
  },
  {
    "route": "/education/mathematics/fractions/exercises",
    "source": "Pages/Mathematics/Fractions/FractionsPage.razor"
  },
  {
    "route": "/education/mathematics/functions",
    "source": "Pages/Mathematics/Functions/FunctionsPage.razor"
  },
  {
    "route": "/education/mathematics/functions/exercises",
    "source": "Pages/Mathematics/Functions/FunctionsPage.razor"
  },
  {
    "route": "/education/mathematics/gcd",
    "source": "Pages/Mathematics/Gcd/GcdPage.razor"
  },
  {
    "route": "/education/mathematics/gcd/exercises",
    "source": "Pages/Mathematics/Gcd/GcdPage.razor"
  },
  {
    "route": "/education/mathematics/geometry",
    "source": "Pages/Mathematics/Geometry/GeometryPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/angoli",
    "source": "Pages/Mathematics/Geometry/Angoli/AngoliPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/angoli/exercises",
    "source": "Pages/Mathematics/Geometry/Angoli/AngoliPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/foundations",
    "source": "Pages/Mathematics/Geometry/Foundations/GeometryFoundationsPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/foundations/exercises",
    "source": "Pages/Mathematics/Geometry/Foundations/GeometryFoundationsPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/piana",
    "source": "Pages/Mathematics/Geometry/GeometryPianaPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/piana/exercises",
    "source": "Pages/Mathematics/Geometry/GeometryPianaPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/pitagora",
    "source": "Pages/Mathematics/Geometry/Pitagora/PitagoraPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/pitagora/exercises",
    "source": "Pages/Mathematics/Geometry/Pitagora/PitagoraPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/proofs",
    "source": "Pages/Mathematics/Geometry/Proofs/GeometryProofsPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/proofs/exercises",
    "source": "Pages/Mathematics/Geometry/Proofs/GeometryProofsPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/similarity-talete",
    "source": "Pages/Mathematics/Geometry/SimilarityTalete/SimilarityTaletePage.razor"
  },
  {
    "route": "/education/mathematics/geometry/similarity-talete/exercises",
    "source": "Pages/Mathematics/Geometry/SimilarityTalete/SimilarityTaletePage.razor"
  },
  {
    "route": "/education/mathematics/geometry/transformations",
    "source": "Pages/Mathematics/Geometry/Transformations/GeometryTransformationsPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/transformations/exercises",
    "source": "Pages/Mathematics/Geometry/Transformations/GeometryTransformationsPage.razor"
  },
  {
    "route": "/education/mathematics/geometry/triangle-congruence",
    "source": "Pages/Mathematics/Geometry/TriangleCongruence/TriangleCongruencePage.razor"
  },
  {
    "route": "/education/mathematics/geometry/triangle-congruence/exercises",
    "source": "Pages/Mathematics/Geometry/TriangleCongruence/TriangleCongruencePage.razor"
  },
  {
    "route": "/education/mathematics/geometry/tridimensionale",
    "source": "Pages/Mathematics/Geometry/GeometryTridimensionalePage.razor"
  },
  {
    "route": "/education/mathematics/geometry/tridimensionale/exercises",
    "source": "Pages/Mathematics/Geometry/GeometryTridimensionalePage.razor"
  },
  {
    "route": "/education/mathematics/graph-theory-algorithms",
    "source": "Pages/Mathematics/GraphTheoryAlgorithms/GraphTheoryAlgorithmsPage.razor"
  },
  {
    "route": "/education/mathematics/graph-theory-algorithms/exercises",
    "source": "Pages/Mathematics/GraphTheoryAlgorithms/GraphTheoryAlgorithmsPage.razor"
  },
  {
    "route": "/education/mathematics/information-theory",
    "source": "Pages/Mathematics/InformationTheory/InformationTheoryPage.razor"
  },
  {
    "route": "/education/mathematics/information-theory/exercises",
    "source": "Pages/Mathematics/InformationTheory/InformationTheoryPage.razor"
  },
  {
    "route": "/education/mathematics/lcm",
    "source": "Pages/Mathematics/Lcm/LcmPage.razor"
  },
  {
    "route": "/education/mathematics/lcm/exercises",
    "source": "Pages/Mathematics/Lcm/LcmPage.razor"
  },
  {
    "route": "/education/mathematics/linear-algebra",
    "source": "Pages/Mathematics/LinearAlgebra/LinearAlgebraPage.razor"
  },
  {
    "route": "/education/mathematics/linear-algebra/exercises",
    "source": "Pages/Mathematics/LinearAlgebra/LinearAlgebraPage.razor"
  },
  {
    "route": "/education/mathematics/machine-learning-math",
    "source": "Pages/Mathematics/MachineLearningMath/MachineLearningMathPage.razor"
  },
  {
    "route": "/education/mathematics/machine-learning-math/exercises",
    "source": "Pages/Mathematics/MachineLearningMath/MachineLearningMathPage.razor"
  },
  {
    "route": "/education/mathematics/measurements-problems",
    "source": "Pages/Mathematics/Primary/MeasurementsProblems/MeasurementsProblemsPage.razor"
  },
  {
    "route": "/education/mathematics/measurements-problems/exercises",
    "source": "Pages/Mathematics/Primary/MeasurementsProblems/MeasurementsProblemsPage.razor"
  },
  {
    "route": "/education/mathematics/natural-numbers",
    "source": "Pages/Mathematics/NaturalNumbers/NaturalNumbersPage.razor"
  },
  {
    "route": "/education/mathematics/natural-numbers/exercises",
    "source": "Pages/Mathematics/NaturalNumbers/NaturalNumbersPage.razor"
  },
  {
    "route": "/education/mathematics/notebook-management",
    "source": "Pages/Mathematics/Notebook/NotebookManagementPage.razor"
  },
  {
    "route": "/education/mathematics/numerical-methods",
    "source": "Pages/Mathematics/NumericalMethods/NumericalMethodsPage.razor"
  },
  {
    "route": "/education/mathematics/numerical-methods/exercises",
    "source": "Pages/Mathematics/NumericalMethods/NumericalMethodsPage.razor"
  },
  {
    "route": "/education/mathematics/percentage-applications",
    "source": "Pages/Mathematics/PercentageApplications/PercentageApplicationsPage.razor"
  },
  {
    "route": "/education/mathematics/percentage-applications/exercises",
    "source": "Pages/Mathematics/PercentageApplications/PercentageApplicationsPage.razor"
  },
  {
    "route": "/education/mathematics/percentages",
    "source": "Pages/Mathematics/Percentage/PercentagePage.razor"
  },
  {
    "route": "/education/mathematics/percentages/exercises",
    "source": "Pages/Mathematics/Percentage/PercentagePage.razor"
  },
  {
    "route": "/education/mathematics/powers-roots",
    "source": "Pages/Mathematics/PowersRoots/PowersRootsPage.razor"
  },
  {
    "route": "/education/mathematics/powers-roots/exercises",
    "source": "Pages/Mathematics/PowersRoots/PowersRootsPage.razor"
  },
  {
    "route": "/education/mathematics/primary-logic",
    "source": "Pages/Mathematics/Primary/PrimaryLogic/PrimaryLogicPage.razor"
  },
  {
    "route": "/education/mathematics/primary-logic/exercises",
    "source": "Pages/Mathematics/Primary/PrimaryLogic/PrimaryLogicPage.razor"
  },
  {
    "route": "/education/mathematics/primes",
    "source": "Pages/Mathematics/Primes/PrimesPage.razor"
  },
  {
    "route": "/education/mathematics/primes/exercises",
    "source": "Pages/Mathematics/Primes/PrimesPage.razor"
  },
  {
    "route": "/education/mathematics/probability-statistics-advanced",
    "source": "Pages/Mathematics/AdvancedStatistics/ProbabilityStatisticsAdvancedPage.razor"
  },
  {
    "route": "/education/mathematics/probability-statistics-advanced/exercises",
    "source": "Pages/Mathematics/AdvancedStatistics/ProbabilityStatisticsAdvancedPage.razor"
  },
  {
    "route": "/education/mathematics/proportions",
    "source": "Pages/Mathematics/Proportions/ProportionsPage.razor"
  },
  {
    "route": "/education/mathematics/proportions/exercises",
    "source": "Pages/Mathematics/Proportions/ProportionsPage.razor"
  },
  {
    "route": "/education/mathematics/rational-decimals",
    "source": "Pages/Mathematics/RationalDecimals/RationalDecimalsPage.razor"
  },
  {
    "route": "/education/mathematics/rational-decimals/exercises",
    "source": "Pages/Mathematics/RationalDecimals/RationalDecimalsPage.razor"
  },
  {
    "route": "/education/mathematics/relative-integers",
    "source": "Pages/Mathematics/RelativeIntegers/RelativeIntegersPage.razor"
  },
  {
    "route": "/education/mathematics/relative-integers/exercises",
    "source": "Pages/Mathematics/RelativeIntegers/RelativeIntegersPage.razor"
  },
  {
    "route": "/education/mathematics/repeating-decimals",
    "source": "Pages/Mathematics/RepeatingDecimals/RepeatingDecimalsPage.razor"
  },
  {
    "route": "/education/mathematics/repeating-decimals/exercises",
    "source": "Pages/Mathematics/RepeatingDecimals/RepeatingDecimalsPage.razor"
  },
  {
    "route": "/education/mathematics/sets",
    "source": "Pages/Mathematics/Sets/SetsPage.razor"
  },
  {
    "route": "/education/mathematics/sets/exercises",
    "source": "Pages/Mathematics/Sets/SetsPage.razor"
  },
  {
    "route": "/education/mathematics/square-root-estimation",
    "source": "Pages/Mathematics/SquareRootEstimation/SquareRootEstimationPage.razor"
  },
  {
    "route": "/education/mathematics/square-root-estimation/exercises",
    "source": "Pages/Mathematics/SquareRootEstimation/SquareRootEstimationPage.razor"
  },
  {
    "route": "/education/mathematics/statistical-graphs",
    "source": "Pages/Mathematics/StatisticalGraphs/StatisticalGraphsPage.razor"
  },
  {
    "route": "/education/mathematics/statistical-graphs/bar-charts",
    "source": "Pages/Mathematics/StatisticalGraphs/BarChartsPage.razor"
  },
  {
    "route": "/education/mathematics/statistical-graphs/choosing-a-chart",
    "source": "Pages/Mathematics/StatisticalGraphs/ChoosingChartPage.razor"
  },
  {
    "route": "/education/mathematics/statistical-graphs/data-tables",
    "source": "Pages/Mathematics/StatisticalGraphs/DataTablesPage.razor"
  },
  {
    "route": "/education/mathematics/statistical-graphs/exercises",
    "source": "Pages/Mathematics/StatisticalGraphs/StatisticalGraphsExercisesPage.razor"
  },
  {
    "route": "/education/mathematics/statistical-graphs/histograms",
    "source": "Pages/Mathematics/StatisticalGraphs/HistogramsPage.razor"
  },
  {
    "route": "/education/mathematics/statistical-graphs/line-charts",
    "source": "Pages/Mathematics/StatisticalGraphs/LineChartsPage.razor"
  },
  {
    "route": "/education/mathematics/statistical-graphs/pictograms",
    "source": "Pages/Mathematics/StatisticalGraphs/PictogramsPage.razor"
  },
  {
    "route": "/education/mathematics/statistical-graphs/pie-charts",
    "source": "Pages/Mathematics/StatisticalGraphs/PieChartsPage.razor"
  },
  {
    "route": "/education/mathematics/statistical-graphs/reading-charts",
    "source": "Pages/Mathematics/StatisticalGraphs/ReadingChartsPage.razor"
  },
  {
    "route": "/education/mathematics/statistical-graphs/scatter-plots",
    "source": "Pages/Mathematics/StatisticalGraphs/ScatterPlotsPage.razor"
  },
  {
    "route": "/education/mathematics/statistics-probability",
    "source": "Pages/Mathematics/StatisticsProbability/StatisticsProbabilityPage.razor"
  },
  {
    "route": "/education/mathematics/statistics-probability/exercises",
    "source": "Pages/Mathematics/StatisticsProbability/StatisticsProbabilityPage.razor"
  },
  {
    "route": "/education/mathematics/tabelline",
    "source": "Pages/Mathematics/Arithmetic/Tabellina/TabellinaPage.razor"
  },
  {
    "route": "/education/mathematics/tabelline/exercises",
    "source": "Pages/Mathematics/Arithmetic/Tabellina/TabellinaPage.razor"
  },
  {
    "route": "/education/mathematics/trigonometry",
    "source": "Pages/Mathematics/Trigonometry/TrigonometryPage.razor"
  },
  {
    "route": "/education/mathematics/trigonometry/exercises",
    "source": "Pages/Mathematics/Trigonometry/TrigonometryPage.razor"
  },
  {
    "route": "/education/memory",
    "source": "Pages/Memory/MemoryPage.razor"
  },
  {
    "route": "/education/memory/come-studiare",
    "source": "Pages/Memory/MemoryStudyPage.razor"
  },
  {
    "route": "/education/memory/games",
    "source": "Pages/Memory/MemoryPage.razor"
  },
  {
    "route": "/education/memory/metodi",
    "source": "Pages/Memory/MemoryMetodiPage.razor"
  },
  {
    "route": "/education/memory/sistemi-orientali",
    "source": "Pages/Memory/MemoryOrientaliPage.razor"
  },
  {
    "route": "/education/memory/srs",
    "source": "Pages/Memory/MemorySrsPage.razor"
  },
  {
    "route": "/education/music",
    "source": "Pages/Music/MusicPage.razor"
  },
  {
    "route": "/education/music/accordi",
    "source": "Pages/Music/MusicAccordPage.razor"
  },
  {
    "route": "/education/music/note",
    "source": "Pages/Music/MusicNotePage.razor"
  },
  {
    "route": "/education/music/scale",
    "source": "Pages/Music/MusicScalePage.razor"
  },
  {
    "route": "/education/music/spartito",
    "source": "Pages/Music/MusicSpartitPage.razor"
  },
  {
    "route": "/education/physics",
    "source": "Pages/Physics/PhysicsPage.razor"
  },
  {
    "route": "/education/physics/cinematica",
    "source": "Pages/Physics/PhysicsCinematicaPage.razor"
  },
  {
    "route": "/education/physics/constants",
    "source": "Pages/Physics/PhysicsConstantsPage.razor"
  },
  {
    "route": "/education/physics/dinamica",
    "source": "Pages/Physics/PhysicsDinamicaPage.razor"
  },
  {
    "route": "/education/physics/energia",
    "source": "Pages/Physics/PhysicsEnergiaPage.razor"
  },
  {
    "route": "/education/physics/forze",
    "source": "Pages/Physics/PhysicsForzePage.razor"
  },
  {
    "route": "/education/physics/misure",
    "source": "Pages/Physics/PhysicsMisurePage.razor"
  },
  {
    "route": "/education/physics/onde",
    "source": "Pages/Physics/PhysicsOndePage.razor"
  },
  {
    "route": "/education/physics/temperatura",
    "source": "Pages/Physics/PhysicsTemperaturePage.razor"
  },
  {
    "route": "/education/physics/termodinamica",
    "source": "Pages/Physics/PhysicsTermodinamicaPage.razor"
  },
  {
    "route": "/education/science",
    "source": "Pages/Science/SciencePage.razor"
  },
  {
    "route": "/education/science/chemical-formula",
    "source": "Pages/Science/ChemicalFormulaPage.razor"
  },
  {
    "route": "/education/science/periodic-table",
    "source": "Pages/Science/PeriodicTablePage.razor"
  },
  {
    "route": "/education/science/seasons",
    "source": "Pages/Science/SeasonsPage.razor"
  },
  {
    "route": "/education/science/solar-system",
    "source": "Pages/Science/SolarSystemPage.razor"
  },
  {
    "route": "/education/science/solar-system/{Slug}",
    "source": "Pages/Science/PlanetPage.razor"
  },
  {
    "route": "/education/science/states-of-matter",
    "source": "Pages/Science/StatesOfMatterPage.razor"
  },
  {
    "route": "/education/spanish",
    "source": "Pages/Spanish/SpanishPage.razor"
  },
  {
    "route": "/education/spanish/course",
    "source": "Pages/Spanish/Course/SpanishCoursePage.razor"
  },
  {
    "route": "/education/spanish/course/unit-{Number:int}",
    "source": "Pages/Spanish/Course/SpanishUnitPage.razor"
  },
  {
    "route": "/education/spanish/grammar",
    "source": "Pages/Spanish/SpanishGrammarPage.razor"
  },
  {
    "route": "/education/spanish/vocabulary",
    "source": "Pages/Spanish/SpanishVocabularyPage.razor"
  },
  {
    "route": "/Error",
    "source": "Pages/Error.razor"
  },
  {
    "route": "/family-groups",
    "source": "Pages/Users/FamilyGroupsPage.razor"
  },
  {
    "route": "/frazioni",
    "source": "Pages/FractionSolver.razor"
  },
  {
    "route": "/not-found",
    "source": "Pages/NotFound.razor"
  },
  {
    "route": "/programma-didattico",
    "source": "Pages/DidacticProgram/Index.razor"
  },
  {
    "route": "/programma-didattico/{school}/{year:int}/{subject?}",
    "source": "Pages/DidacticProgram/List.razor"
  },
  {
    "route": "/programma-didattico/{school}/{year:int}/{subject}/{month:int}",
    "source": "Pages/DidacticProgram/Detail.razor"
  },
  {
    "route": "/programmi-didattici",
    "source": "Pages/DidacticPrograms/DidacticProgramsIndex.razor"
  },
  {
    "route": "/programmi-didattici/{SchoolSlug}/{ClassSlug}",
    "source": "Pages/DidacticPrograms/ClassDetail.razor"
  },
  {
    "route": "/programmi-didattici/{SchoolSlug}/{ClassSlug}/{Subject}",
    "source": "Pages/DidacticPrograms/SubjectDetail.razor"
  },
  {
    "route": "/programmi-didattici/{schoolSlug}/{classSlug}/{subject}/quiz",
    "source": "Pages/DidacticPrograms/SubjectQuiz.razor"
  },
  {
    "route": "/programmi-didattici/{schoolSlug}/{classSlug}/quiz",
    "source": "Pages/DidacticPrograms/ClassQuiz.razor"
  },
  {
    "route": "/quiz",
    "source": "Pages/Quiz/Quiz.razor"
  },
  {
    "route": "/quiz/catalogo",
    "source": "Pages/Quiz/QuizCatalog.razor"
  },
  {
    "route": "/quiz/result",
    "source": "Pages/Quiz/Results.razor"
  },
  {
    "route": "/quiz/session/{QuizId:guid}",
    "source": "Pages/Quiz/QuizSessionDetail.razor"
  },
  {
    "route": "/quiz/statistiche",
    "source": "Pages/Quiz/MyStats.razor"
  },
  {
    "route": "/release-notes",
    "source": "Pages/ReleaseNotes/ReleaseNotesPage.razor"
  },
  {
    "route": "/schools",
    "source": "Pages/Users/SchoolsPage.razor"
  },
  {
    "route": "/student/list",
    "source": "Pages/Users/StudentList.razor"
  },
  {
    "route": "/student/register",
    "source": "Pages/Users/StudentRegistration.razor"
  },
  {
    "route": "/study-program/weekly-schedule",
    "source": "Pages/StudyProgram/WeeklySchedule.razor"
  },
  {
    "route": "/teacher/list",
    "source": "Pages/Users/TeacherList.razor"
  },
  {
    "route": "/users/students/edit/{StudentId:guid}",
    "source": "Pages/Users/StudentEditPage.razor"
  },
  {
    "route": "/weather",
    "source": "Pages/Weather.razor"
  }
] as const;
